import { Box, Typography } from '@mui/material';
import React from 'react';

const ComingSoonBadge = () => {
  return (
    <Box
      sx={{
        py: 0.5,
        px: 1,
        backgroundColor: '#1958B8',
        borderRadius: '24px',
        width: 'max-content'
      }}>
      <Typography
        sx={{ color: '#FFF', textTransform: 'capitalize', lineHeight: 1 }}
        fontSize={'0.7rem'}>
        Coming soon
      </Typography>
    </Box>
  );
};

export default ComingSoonBadge;
